import { render, staticRenderFns } from "./StocktakingRecordAdd.vue?vue&type=template&id=8ad35c56&scoped=true&"
import script from "./StocktakingRecordAdd.vue?vue&type=script&lang=js&"
export * from "./StocktakingRecordAdd.vue?vue&type=script&lang=js&"
import style0 from "./StocktakingRecordAdd.vue?vue&type=style&index=0&id=8ad35c56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad35c56",
  null
  
)

export default component.exports